import { render, staticRenderFns } from "./AddSalesOrderComponent.vue?vue&type=template&id=5de751b0"
import script from "./AddSalesOrderComponent.vue?vue&type=script&lang=js"
export * from "./AddSalesOrderComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports